<script>
	import OutboundLink from 'components/outbound-link.vue';
	import utilities from 'utilities';
	import analyticsUtilities from 'utilities/analyticsUtilities';

	export default {
		components: {
			'outbound-link': OutboundLink
		},
		props: {
			headerText: {
				type: String
			},
			panels: {
				type: Array,
				required: true
			}
		},
		computed: {
			panelContent() {
				return this.panels[0];
			}
		},
		methods: {
			isExternalLink(link) {
				return utilities.isExternalLink(link);
			},
			homepageClick(loc) {
				analyticsUtilities.fireEvent(analyticsUtilities.events.HOMEPAGE_CLICK, {
					loc
				});
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/media';

	.message-panel {
		padding-bottom: 4rem;

		h2 {
			margin: 1rem 0;
			color: $c-blue-accent-2;
		}

		.actions {
			display: grid;
			gap: 1rem;
			grid-template-columns: 1fr;
			white-space: nowrap;
			padding: 0 1rem;

			@include media(med) {
				font-size: 1.125rem;
				grid-template-columns: repeat(2, 1fr);
			}

			@include media(lg) {
				grid-template-columns: repeat(4, 1fr);
			}
		}

		.panel-action {
			display: block;
			padding: 0.75rem;
			height: 100%;
			text-align: center;
			border-radius: 2.5rem;

			@include media(lg) {
				padding: 0.75rem 2.5rem;
			}
		}
	}
</style>
<template>
	<section class="message-panel">
		<div class="wrapper">
			<h2 v-if="headerText">{{ headerText }}</h2>
			<p class="panel-content">{{ panelContent.content_text }}</p>
			<ul class="actions list-unstyled">
				<li
					v-for="action in panelContent.actions"
					:key="action.url"
					class="action">
					<outbound-link
						v-if="isExternalLink(action.url)"
						class="panel-card panel-action"
						:href="action.url"
						:data-outbound-link="action.tag || 'MESSAGE_PANEL_LINK'">
						{{ action.text }}
					</outbound-link>
					<a
						v-else
						class="panel-card panel-action"
						:href="action.url"
						@click="homepageClick(action.tag || 'MESSAGE_PANEL_LINK')">
						{{ action.text }}
					</a>
				</li>
			</ul>
		</div>
	</section>
</template>
